module.exports = __webpack_public_path__ + "img/edit-table.13906b34.png";